import axios from '@/axios'

export default {
  fetchAll(params){
    return axios.get(`/material-analysis/all`, {params})
  },
  fetchLimit(params){
    return axios.get(`/material-analysis`, {params})
  }   
}